import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import ReactQuill from "react-quill"; // Import react-quill
import "react-quill/dist/quill.snow.css"; // Import the Quill CSS for the snow theme
import { useActivityLogger } from "./hooks/useActivity";
import { useEffect } from "react";
export default function AdminUploadArticle() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    author: "",
    source: "",
    url: "",
    tags: "",
    content: "",
    published_date: "",
    category_id: "",
  });

  const [categories, setCategories] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const { logAdminActivity } = useActivityLogger();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/kategori");
        setCategories(res.data);
      } catch (err) {
        console.error("Gagal mengambil kategori", err);
      }
    };
    fetchCategories();
  }, []);
  // const categories = [
  //   "Gejala Stroke",
  //   "Rehabilitasi Stroke",
  //   "Pengobatan Stroke",
  //   "Testimoni Penyintas Stroke",
  //   "Obat Stroke",
  //   "Edukasi Kesehatan Umum",
  //   "Dukungan Agama Islam",
  //   "Dukungan Agama Kristen",
  //   "Dukungan Agama Katholik",
  //   "Dukungan Agama Hindu",
  //   "Dukungan Agama Buddha",
  //   "Dukungan Agama Konghucu",
  //   "Kepercayaan Lainnya",
  // ];
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 5 * 1024 * 1024) {
      alert(
        "Ukuran gambar melebihi 4MB. Silakan unggah gambar yang lebih kecil."
      );
      e.target.value = null;
      return;
    }
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("title", formData.title);
      data.append("author", formData.author);
      data.append("source", formData.source);
      data.append("url", formData.url);
      data.append("tag", formData.tags);
      data.append("content", formData.content);
      data.append("published_date", formData.published_date);
      data.append("kategori", formData.kategori);
      if (imageFile) {
        data.append("image", imageFile);
      }

      const response = await api.post("/articles", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      logAdminActivity(
        "create",
        "create_admin_article",
        "article",
        response.data.id,
        formData.title || "Unknown Article",
        "success",
        "",
        `Admin mengupload artikel ${formData.title || "Unknown Article"}`
      );
      alert("Artikel berhasil diupload");
      navigate("/admin/article");
    } catch (error) {
      console.error("Gagal upload artikel:", error);
      alert("Terjadi kesalahan saat mengupload artikel: " + error.message);
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-6 rounded shadow">
          <button
            onClick={() => navigate(-1)}
            className="text-xl text-black font-semibold mb-8"
          >
            &lt; Upload Artikel
          </button>

          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <div>
              <label className="text-sm block mb-1">Judul</label>
              <input
                type="text"
                name="title"
                placeholder="Judul"
                value={formData.title}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Penulis</label>
              <input
                type="text"
                name="author"
                placeholder="Penulis"
                value={formData.author}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Sumber</label>
              <input
                type="text"
                name="source"
                placeholder="Sumber"
                value={formData.source}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">URL Artikel</label>
              <input
                type="text"
                name="url"
                placeholder="URL artikel"
                value={formData.url}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">
                Tag{" "}
                <span className="text-gray-500">(maks. 5, dipisah koma)</span>
              </label>
              <input
                type="text"
                name="tags"
                placeholder="Tag"
                value={formData.tags}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Tanggal Publikasi</label>
              <input
                type="date"
                name="published_date"
                value={formData.published_date}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="text-sm block mb-1">Kategori (opsional)</label>
              <select
                name="category_id"
                value={formData.category_id || ""}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              >
                <option value="">-- Pilih Kategori --</option>

                {categories.map((cat) => (
                  <option key={cat.ID} value={cat.ID}>
                    {cat.nama_kategori}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm block mb-1">
                Upload Gambar (opsional, max file size 4 MB)
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="w-full text-sm mb-2"
              />
              {imagePreview && (
                <div className="mt-2">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="max-h-40 rounded border"
                  />
                </div>
              )}
            </div>
            <div className="md:col-span-2">
              <label className="text-sm block mb-1">Artikel</label>
              {/* Use ReactQuill for rich text input */}
              <ReactQuill
                value={formData.content}
                onChange={handleQuillChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>
            <div className="md:col-span-2 flex justify-end">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Upload
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
